import { useMount } from "react-use"

import { useAgentState } from "@/agent-state"
import { persistenceService } from "@/agent-state/persistence"
import CallView from "@/components/CallView"
import { StatelessResetView } from "@/components/ResetCallView/stateless-reset-view"
import { useCallPanelLogger } from "@/hooks/useLogger"

export function BusyView() {
  const {
    state: {
      context: { taskData },
    },
  } = useAgentState()

  const { caseData, studentProfile } = taskData || {}

  if (!studentProfile || !caseData) return <InconsistentState />

  return <CallView studentProfile={studentProfile} currentCase={caseData} />
}

/** Not supposed to happen if the state machine is setup properly but we need to investigate if such a situation happens */
function InconsistentState() {
  const log = useCallPanelLogger()

  function refresh() {
    persistenceService.reset()
    window.location.href = "/"
  }

  useMount(() => {
    log.error("Inconsistent state")
  })

  return <StatelessResetView onRefreshPage={refresh} />
}
